import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "moreLabel", "lessLabel"]

  toggle() {
    this.itemTargets.forEach((item) => item.classList.toggle("hidden"))
    this.moreLabelTarget.classList.toggle("hidden")
    this.lessLabelTarget.classList.toggle("hidden")
  }
}
